import * as React from "react";
import { useMemo, forwardRef } from "react";
import styled from "styled-components";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import { BLANK } from "views/components/contexts/SearchPageLayoutContext";
import SearchPage from "views/pages/SearchPage";
import SearchPageLayoutProvider from "views/components/contexts/SearchPageLayoutProvider";
import ViewDeserializer from "views/logic/views/ViewDeserializer";
const StyledPageContentLayout = styled.div`
  padding: 0 15px;
`;
const SearchAreaContainer = forwardRef(({ children }, ref) => /* @__PURE__ */ React.createElement(StyledPageContentLayout, { ref }, children));
const MetricsSearchView = ({ viewJson }) => {
  const view = useMemo(() => ViewDeserializer(viewJson), [viewJson]);
  const searchPageLayoutContextValue = {
    sidebar: { isShown: false },
    viewActions: BLANK,
    searchAreaContainer: { component: SearchAreaContainer }
  };
  return /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: false }, /* @__PURE__ */ React.createElement(SearchPageLayoutProvider, { value: searchPageLayoutContextValue }, /* @__PURE__ */ React.createElement(SearchPage, { view, isNew: false, skipNoStreamsCheck: true })));
};
export default MetricsSearchView;
